export default store => next => action => {
    console.group(action.type);
    console.info('dispatching', action);
    const result = next(action);
    console.info('next state', store.getState());
    console.groupEnd(action.type);
    return result;
}


// WEBPACK FOOTER //
// ./src/util/loggerMiddleware.js